import React from "react";
import { FrameworkData } from "./useFrameworkData";
import { Tag } from "@multiagentbook/ui";
import ScoreBars from "./ScoreBars";

interface FrameworkCardProps {
  framework: FrameworkData;
  onClick: (framework: FrameworkData) => void;
  isTopFramework: boolean;
  index: number;
  displayScore: number; // Add prop for the score to display (calculated based on selected dims)
}

const FrameworkCard: React.FC<FrameworkCardProps> = ({
  framework,
  onClick,
  isTopFramework,
  index,
  displayScore, // Use the passed displayScore
}) => {
  const getScoreColor = (score: number) => {
    if (score >= 4) return "#3f8600";
    if (score >= 3) return "#faad14";
    return "#cf1322";
  };

  // Use the passed displayScore for color and text
  const scoreColor = getScoreColor(displayScore);
  const scoreText = displayScore.toFixed(1);

  return (
    <div
      className={`cursor-pointer transition-all duration-200 border-secondary p-4 hover:bg-secondary/10 border rounded-lg ${
        isTopFramework ? "ring-2 ring-accent shadow-lg" : ""
      }`}
      onClick={() => onClick(framework)}
    >
      <div className="flex gap-4">
        <div className="flex-shrink-0">
          <img
            alt=""
            src={`/images/news/icon_${(index % 4) + 1}.webp`}
            className="pointer-events-none object-cover group-hover:opacity-75 w-12 h-full rounded"
          />
        </div>

        <div className="flex-1 flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold">
              {framework.framework_name}
            </h3>
            <div className="flex items-center">
              <Tag
                color="green"
                className="text-lg font-semibold px-3 py-1 rounded-full"
              >
                {scoreText}
              </Tag>
              {isTopFramework && (
                <span className="bg-accent text-white text-xs px-2 py-1 rounded-full ml-2">
                  Top Pick
                </span>
              )}
            </div>
          </div>

          {/* Description */}
          <div className="text-sm text-secondary mb-2 line-clamp-2">
            {framework.framework_summary}
          </div>

          {/* Score bars visualization */}
          <ScoreBars dimensions={framework.dimensions} />
        </div>
      </div>
    </div>
  );
};

export default FrameworkCard;
